import { useEffect, useState } from 'react';
import { AppWatch } from '@wajeez/wajeez.microservices';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import moment from 'moment';

const DailyDowngradeSubscriptionChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const { dailyDowngradeSubscription, dailyDowngradeSubscriptionStatus } =
    useAppwatchSelector((c) => c.paymentAnalysis);

  const [purchaseSource, setPurchaseSource] =
    useState<AppWatch.PurchaseSourceType>(
      AppWatch.PurchaseSourceType.CARD_DIRECT
    );

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyDowngradeSubscriptionAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        purchaseSourceType: purchaseSource,
      })
    );
  }, [dates, purchaseSource]);

  return (
    <div className="col-span-`1">
      {' '}
      <Card>
        <div className="space-y-2">
          <ChartHeader
            title="Daily Downgrade Subscription"
            dates={dates}
            PurchaseSourceAction={(purchaseSource) =>
              setPurchaseSource(purchaseSource)
            }
            purchaseSource={purchaseSource}
            subTitle={
              dailyDowngradeSubscription?.total &&
              dailyDowngradeSubscriptionStatus !== 'loading'
                ? `المجموع: ${dailyDowngradeSubscription?.total}`
                : ''
            }
          />

          <ChartDisplay
            loading={dailyDowngradeSubscriptionStatus === 'loading'}
            formatter={(value, time) => {
              return (
                moment.utc(value).local().locale('en').format('DD/MM/YYYY') ||
                value
              );
            }}
            chartType="area"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            seriesData={[
              {
                type: 'area',
                name: 'Users',
                data:
                  dailyDowngradeSubscription?.items?.map((element) => ({
                    y: element.count || 0,

                    x: element.startDate || '',
                  })) || [],
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyDowngradeSubscriptionChart;
